import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};

// Line-by-line masked reveal for headings. `lines` = array of strings.
export const MaskText = ({ lines = [], start = true, delay = 0, className = "", lineClassName = "" }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? false : { y: "110%" }}
            animate={start ? { y: "0%" } : { y: "110%" }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export default Reveal;
